import { FC } from 'react'
import notFound from '../../../assets/images/not_found.png'
import { StyledHeading, StyledDescription, StyledBox } from './NotFoundBase.styles'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { useClientConfigurationQuery } from '@client-hub/store/api/crs/react'

export interface Props {
  returnToHomeLink: string
}

const NotFoundBase: FC<Props> = ({ returnToHomeLink }) => {
  const { t } = useTranslation('shared', { keyPrefix: 'notFound' })
  const { isSuccess } = useClientConfigurationQuery()

  return (
    <StyledBox>
      <img src={notFound} alt="not-found" />
      <StyledHeading variant="h2">{t('sorry')}</StyledHeading>
      <StyledDescription>{t('missingOrBroken')}</StyledDescription>
      {/* If we're unable to determine the client/client config, don't offer a returnToHome link */}
      {isSuccess && <Link to={returnToHomeLink}>{t('returnHome')}</Link>}
    </StyledBox>
  )
}

export default NotFoundBase
